import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";

// Custom Imports
import DataTable from "../../components/DataTable";
import Dashboard from "../../layouts/Dashboard";
import axios from "../../services/axios";
import isConsultant from "../../services/isConsultant";

function DocumentForms() {
  const [documents, setDocuments] = useState([]);
  const history = useHistory();

  // Effects and Events
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get("/documents", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        });
        setDocuments(data);
      } catch (e) {
        console.error(e.response.data);
      }
    })();
  }, []);
  return (
    <div>
    {!isConsultant() && <Dashboard title="Joining Forms">
      <div className="mb-4">
        <DataTable
          columns={["title"]}
          rows={documents}
          options={(document, index, redrawTable) => (
            <>
              <Link to={"/documents/" + document._id + "/edit"}>
                <button className="btn btn-sm  btn-primary">
                  <i class="fa fa-edit mr-1"></i>
                  Edit
                </button>
              </Link>
              {/* <button
              className="btn btn-danger"
              onClick={async () => {
                try {
                  await axios.delete("/documents/" + document._id);
                  // documents.splice(index, 1);
                  // setDocuments([...documents]);
                  history.go(0);
                } catch (e) {
                  console.error(e);
                }
              }}
            >
              Delete
            </button> */}
            </>
          )}
        />
        <Link to="/documents/create">
          <button className="btn btn-success ">Create New</button>
        </Link>
      </div>
    </Dashboard>}
    </div>
  );
}

export default DocumentForms;
